// Phase-6 helpers shared across all case views.

/** Zero-pad case_number to 3 digits up to 999, then natural width above. */
export const formatCaseNumber = (n) => {
  if (n === null || n === undefined || n === "") return "—";
  const num = parseInt(n, 10);
  if (Number.isNaN(num)) return "—";
  return num < 1000 ? num.toString().padStart(3, "0") : num.toString();
};
